











/* General */
import Vue from 'vue'
import {
  ContentPlaceholders,
  ContentPlaceholdersText,
} from 'vue-content-placeholders'

/* Mixins */
/* Components */
/* Helpers */
/* Data types */
/* API */

export default Vue.extend({
  name: 'TaskDetailLoading',

  components: {
    ContentPlaceholders,
    ContentPlaceholdersText,
  },
})
